export const expeditionLinks = {
  youtube: "https://www.youtube.com/watch?v=iG57KTDhf0o&list=PLB_KDWv0W5Qo&index=5",
  source: "https://github.com/SoExDobin/Expedition-Portfolio",
};
